<template>
    <v-dialog v-model="shows" max-width="480">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>
                <span class="subtitle-1">미디어 등록</span>
            </v-card-title>
            <v-divider />

            <v-card-text class="py-5">
                <v-row align="center" class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <v-row align="center" class="ma-n2">
                            <v-col class="pa-2">
                                <v-text-field v-model="form.rank" label="우선 순위" hide-details persistent-placeholder />
                            </v-col>
                            <v-col class="pa-2">
                                <v-select v-model="form.label" label="라벨" :items="['미디어', '유튜브']" hide-details persistent-placeholder />
                            </v-col>
                            <v-col class="pa-2" cols="auto">
                                <v-switch v-model="form.isNotice" label="공지여부" dense inset hide-details persistent-placeholder />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.title" label="제목" hide-details persistent-placeholder />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.videoId" label="비디오 아이디" hide-details persistent-placeholder />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-row class="ma-n2" align="center">
                            <v-col class="pa-2" cols="auto">
                                <v-img v-if="form.thumbnail" width="48" height="48" :src="createObjectURL(form.thumbnail)" />
                                <v-responsive v-else width="48" height="48" class="grey lighten-2">
                                    <v-row align="center" class="fill-height" justify="center"><v-icon color="black">mdi-pencil</v-icon></v-row>
                                </v-responsive>
                            </v-col>
                            <v-col class="pa-2">
                                <v-file-input v-model="form.thumbnail" label="비디오 썸네일" hide-details persistent-placeholder show-size accept="image/*" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="shows = false">취소</v-btn>
                <v-btn color="primary" text @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
let initForm = (form = {}) => ({
    ...(form || {}),

    type: form?.type || "목록",
    rank: +(form?.rank ?? 1),
    label: form?.label || "미디어",
    title: form?.title || null,
    videoId: form?.videoId || null,
    isNotice: form?.isNotice ?? false,
    thumbnail: form?.thumbnail || null,
});

export default {
    props: {
        value: { type: Object, default: initForm },
    },
    data: () => ({
        form: initForm(),
        shows: false,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    methods: {
        async init() {
            if (!this.shows) return;
            if (this.isCreate) this.form = initForm();
            else {
                this.loading = true;

                let { _id } = this.value;

                try {
                    let { media } = await api.console.media.get({ _id });

                    if (this.value?._id == _id) {
                        if (media?.thumbnail) {
                            media.thumbnail = await api.getResource(media.thumbnail, true);
                        }

                        this.form = initForm(media);
                    }
                } finally {
                    if (this.value?._id == _id) this.loading = false;
                }
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { post, put } = api.console.media;

                let { thumbnail, ...form } = this.form;

                let { media } = await (this.isCreate ? post : put)(form);

                if (thumbnail instanceof File) {
                    await api.console.media.postThumb({ _id: media._id }, thumbnail);
                }

                alert("저장되었습니다");

                this.$emit("input", media);

                this.loading = false;
                this.shows = false;
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return;
            }
        },
    },
    watch: {
        shows() {
            this.init();
        },
        value() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
